/**
 * Офлайн-черновик анкеты актёра. Цель — НЕ потерять правки при сбое связи:
 * пишем последний несохранённый снимок полей в localStorage по staffId,
 * восстанавливаем при следующем открытии, чистим после успешного сохранения.
 *
 * localStorage достаточно надёжен для черновика — сбой тут сетевой, не в хранилище.
 * Универсальный по типу полей, чтобы не тянуть зависимость из хука (без циклов импортов).
 */
const KEY = (staffId: string): string => `ub:anketaDraft:${staffId}`;

export interface ProfileDraft<T> {
  fields: T;
  ts: number;
}

export function saveDraft<T>(staffId: string, fields: T): void {
  if (!staffId) return;
  try {
    localStorage.setItem(KEY(staffId), JSON.stringify({ fields, ts: Date.now() } satisfies ProfileDraft<T>));
  } catch {
    /* квота/недоступно — не критично */
  }
}

export function loadDraft<T>(staffId: string): ProfileDraft<T> | null {
  if (!staffId) return null;
  try {
    const raw = localStorage.getItem(KEY(staffId));
    if (!raw) return null;
    const d = JSON.parse(raw) as ProfileDraft<T>;
    return d && d.fields ? d : null;
  } catch {
    return null;
  }
}

export function clearDraft(staffId: string): void {
  if (!staffId) return;
  try {
    localStorage.removeItem(KEY(staffId));
  } catch {
    /* noop */
  }
}
